import React, { useRef } from 'react';
import * as THREE from 'three';

export const PointLight = ({position, lightColor = 'red', helper = false}) => {
  const light = useRef();
  // useHelper(light, THREE.PointLightHelper)
  return <pointLight position={position} intensity={0.25} color={lightColor} ref={light} castShadow />
}